import React, { useState } from 'react';
import './components.css';
import logoImg from './img/logo-trans.png';

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="header">
      <a href="#top" className="logo">
        <img src={logoImg} alt="" className="logo-mark" />
        <span className="logo-text">
          The Happy Book Stack
          <small>A Utah Reading Room</small>
        </span>
      </a>

      <nav aria-label="Primary">
        <a href="#featured">Shelf</a>
        <a href="#about">Story</a>
        <a href="#calendar">Events</a>
        <a href="#trading">Trade</a>
        <a href="#visit">Visit</a>
      </nav>

      <button
        className="menu-toggle"
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {open ? '✕' : '☰'}
      </button>

      <div
        className={`mobile-menu${open ? ' open' : ''}`}
        onClick={() => setOpen(false)}
      >
        <a href="#featured">Shelf</a>
        <a href="#about">Story</a>
        <a href="#calendar">Events</a>
        <a href="#trading">Trade</a>
        <a href="#visit">Visit</a>
      </div>
    </header>
  );
}

export default Header;
